import { createApp } from "vue"
import PermissionBlock from "./PermissionBlock.vue"
import handleComponentProps from "../../foundation/js/utils/handleComponentProps"

const el = ".nyk-component--permission-block"

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((PermissionBlockDOM) => {
            const props = handleComponentProps(PermissionBlock, PermissionBlockDOM)
            const component = createApp(PermissionBlock, props).use(Store)
            component.mount(PermissionBlockDOM)
        })
    }
}
